import {extensions as mimeToExtensions} from 'mime-types';

import {SafeAndSupportedImageTypes} from '@cdo/generated-scripts/sharedConstants';

import {AppName, ProjectType} from './types';

export const SOURCE_FILE = 'main.json';

export const BLOCKLY_LABS: AppName[] = ['dance', 'music'];

export const LABS_WITH_JSON_SOURCES: AppName[] = ['aichat'];

export const MAIN_PYTHON_FILE = 'main.py';

export enum PERMISSIONS {
  // Add more permissions as needed.
  LEVELBUILDER = 'levelbuilder',
  PROJECT_VALIDATOR = 'project_validator',
}

export const START_SOURCES = 'start_sources';
export const TOOLBOX_BLOCKS = 'toolbox_blocks';
export const EDIT_EXEMPLAR = 'edit_exemplar';
export const WIDGET2_SOURCES = 'widget2_sources';

export const PROJECT_TYPES_USING_NEW_SHARE_DIALOG: ProjectType[] = [
  'music',
  'pythonlab',
  'weblab2',
  'music_dance_ai',
  'sketchlab',
];

// Project types whose content is share-filtered for profanity/PII on the
// server. Must stay in sync with FILTERED_PROJECT_TYPES in
// lib/cdo/share_filtering.rb (for the lab2 project types listed there).
export const PROJECT_TYPES_WITH_SHARE_FILTERING: ProjectType[] = ['sketchlab'];

// Text-based labs that are currently supported by lab2.
export const TEXT_BASED_LABS: AppName[] = ['aichat', 'pythonlab', 'weblab2'];

// Banner messages to show for various modes.
export enum WARNING_BANNER_MESSAGES {
  STANDARD = 'You are editing start sources.',
  TEMPLATE = 'WARNING: You are editing start sources for a level with a template. Start sources should be defined on the template.',
  LOCK_FILES = 'Reminder: lock all start files your validation file references.',
  TOOLBOX_MODE = 'You are editing toolbox blocks.',
  EXEMPLAR_MODE = 'You are editing exemplar sources.',
  VIEWING_EXEMPLAR = 'You are viewing an example solution.',
  VIEWING_VERSION = 'You are viewing an older version of this project. To continue working, you can either restore this version or go back to the current version.',
  EDITING_WIDGET2 = 'You are editing a widget2 ({widgetId}).  Changes will affect all levels that use it.',
}

// Default height of the predict question free response text area.
export const PREDICT_FREE_RESPONSE_DEFAULT_HEIGHT = 50;

export enum FontSize {
  Tiny = 10,
  Small = 13, // Default font size
  Medium = 17,
  Large = 22,
  Huge = 27,
}

export const INITIAL_VERSION_ID = 'initial-version';

export const SUPPORTED_IMAGE_EXTENSIONS = SafeAndSupportedImageTypes.flatMap(
  mime => (mimeToExtensions[mime] ?? []).filter(ext => ext !== 'jpe')
);
